
export default function Services() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            왜 저희를 선택해야 할까요?
          </h2>
          <div className="w-16 h-1 bg-[#007AFF] mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-[#1a1a1a] rounded-[32px] p-12 text-white transform hover:scale-105 transition-transform duration-300">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-6">
              <span className="text-3xl font-bold text-[#1a1a1a]">15</span>
            </div>
            <h3 className="text-3xl font-bold mb-4">년의 경력</h3>
            <p className="text-gray-400 text-base">2010년부터 지속된 전문성</p>
            <div className="mt-8 space-y-3">
              <div className="flex items-center gap-3">
                <i className="ri-check-line text-[#007AFF] text-xl"></i>
                <span className="text-sm">iPhone 3GS부터 최신 기종</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-check-line text-[#007AFF] text-xl"></i>
                <span className="text-sm">iPad 1세대부터 전 모델</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-check-line text-[#007AFF] text-xl"></i>
                <span className="text-sm">15년간 축적된 노하우</span>
              </div>
            </div>
          </div>

          <div className="relative rounded-[32px] overflow-hidden transform hover:scale-105 transition-transform duration-300">
            <img
              src="https://public.readdy.ai/ai/img_res/e69f7ae25ca64b6cf412d1ac6eea2f89.jpg"
              alt="전문 수리"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/40"></div>
            <div className="absolute top-8 left-8">
              <div className="bg-white/20 backdrop-blur-md rounded-full px-4 py-2">
                <span className="text-white font-medium text-sm">전문 수리</span>
              </div>
            </div>
            <div className="absolute bottom-8 left-8 right-8">
              <h3 className="text-3xl font-bold text-white mb-2">정품 부품 사용</h3>
              <p className="text-gray-200 text-sm">높은 퀄리티의 부품만을 사용합니다</p>
            </div>
          </div>

          <div className="bg-white border border-gray-200 rounded-[32px] p-12 transform hover:scale-105 transition-transform duration-300">
            <h3 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Georgia, serif' }}>
              당일 수리
            </h3>
            <p className="text-gray-600 text-base mb-8">빠른 진단과 즉시 수리</p>
            <div className="relative h-48 rounded-2xl overflow-hidden mb-6">
              <img
                src="https://readdy.ai/api/search-image?query=Repaired%20iPhone%20with%20perfect%20screen%20display%2C%20completed%20repair%20result%2C%20pristine%20condition%20iPhone%20on%20white%20surface%2C%20successful%20repair%20outcome%2C%20quality%20service%20result%2C%20like-new%20device%20condition&width=600&height=400&seq=service-img-002&orientation=landscape"
                alt="수리 완료"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <i className="ri-time-line text-[#007AFF] text-xl"></i>
                <span className="text-sm text-gray-700">평균 1-2시간 소요</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-shield-check-line text-[#007AFF] text-xl"></i>
                <span className="text-sm text-gray-700">수리 후 보증 제공</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
